import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  job,
  handleCancelClick,
  increment,
  setJobId,
  jobtypesList,
}) => {
  const [job1, setJob1] = useState(job);
  const axiosPrivate = useAxiosPrivate();

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    if (name === "active") {
      job1.active = e.target.checked;
    } else
      setJob1((prevState) => ({
        ...prevState,
        [name]: value,
      }));
  };
  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);

    setJob1((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const updateData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "job/" + job1.id + "/",
          job1,
          {
            signal: controller.signal,
          }
        );
        //isMounted && setDocuments(response.data);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    updateData();
    setJobId(null);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <tr>
      <td>
        <select name="jobtype" onChange={handleDDSChange} value={job1.jobtype}>
          <option value="" selected>
            בחר מחלקה
          </option>
          {jobtypesList?.map((a) => (
            <option key={a.id} value={a.id}>
              {a.title}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="text"
          name="title"
          className="form-control"
          id="title"
          value={job1.title}
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
